import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  .notes-header,
  .notes-footer {
    flex-shrink: 0;
  }

  .notes-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  .note-card {
    background: ${(props) => props.theme.$gray200};
    border-radius: 6px;
  }

  .note-author {
    color: #284664;
  }

  .note-message {
    color: ${(props) => props.theme.$gray900};
  }

  .note-delete {
    color: ${(props) => props.theme.$danger};
  }

  .notes-input-group .material-icons {
    font-size: 24px;
  }
`;
